import { message } from 'antd';

export const DOMAIN_ACCESS_ERROR = {
  NOT_VERIFIED: 'DOMAIN_NOT_VERIFIED',
  NOT_CLASSIFIED: 'DOMAIN_NOT_CLASSIFIED',
  NOT_APPROVED: 'DOMAIN_NOT_APPROVED',
  NO_METRICS: 'NO_METRICS',
  CLAIMED: 'DOMAIN_CLAIMED',
  LINKEDIN_REQUIRED: 'LINKEDIN_REQUIRED',
};

export const getApiErrorCode = (error) =>
  error?.response?.data?.error || error?.response?.data?.code;

/**
 * Handles domain access API errors.
 * @returns {boolean} true if the error was handled
 */
export function handleDomainAccessError(
  error,
  {
    onNotVerified,
    onNotClassified,
    onNotApproved,
    onClaimed,
    updateProfile,
  } = {}
) {
  const code = getApiErrorCode(error);

  if (code === DOMAIN_ACCESS_ERROR.NOT_APPROVED) {
    // Routing shows the wall from get-profile — never a dashboard toast.
    if (typeof updateProfile === 'function') {
      updateProfile({ silent: true });
    }
    onNotApproved?.();
    return true;
  }

  if (code === DOMAIN_ACCESS_ERROR.NOT_VERIFIED) {
    message.error('Please verify domain ownership before continuing.');
    onNotVerified?.();
    return true;
  }

  if (code === DOMAIN_ACCESS_ERROR.NOT_CLASSIFIED) {
    message.error(
      'We could not analyze your website. Make sure it loads, then try again.'
    );
    onNotClassified?.();
    return true;
  }

  if (code === DOMAIN_ACCESS_ERROR.CLAIMED) {
    // Keyed: Browse refetches several times; show it once.
    message.error({
      key: DOMAIN_ACCESS_ERROR.CLAIMED,
      content: 'This domain is already listed. Verify it to continue.',
    });
    onClaimed?.();
    return true;
  }

  if (code === DOMAIN_ACCESS_ERROR.LINKEDIN_REQUIRED) {
    // Onboarding takes over at the LinkedIn step.
    if (typeof updateProfile === 'function') {
      updateProfile();
    }
    return true;
  }

  if (code === DOMAIN_ACCESS_ERROR.NO_METRICS) {
    message.warning(
      "We're pulling your domain metrics. Try again in a moment."
    );
    return true;
  }

  return false;
}

/** Normalize opportunities/list response (envelope or legacy array). */
export function parseOpportunitiesListResponse(data) {
  if (Array.isArray(data)) {
    return { opportunities: data };
  }

  if (!data || typeof data !== 'object') {
    return { opportunities: [] };
  }

  if (Array.isArray(data.opportunities)) {
    return { opportunities: data.opportunities };
  }

  if (Array.isArray(data.data)) {
    return { opportunities: data.data };
  }

  if (data.data && Array.isArray(data.data.opportunities)) {
    return { opportunities: data.data.opportunities };
  }

  return { opportunities: [] };
}
